<template>
  <div class="info-icon">
    <em
      :id="id"
      class="qx-icon icon-info-circle-o" />
    <qx-tooltip
      :text="title"
      :location="position"
      :origin="origin"
      target="parent" />
  </div>
</template>

<script>
import QxTooltip from '@/elements/QxTooltip.vue';
export default {
  name: 'InfoIcon',
  components: {
    QxTooltip,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    position: {
      type: String,
      default: 'end center',
      validator: (value) => ['start center', 'end center', 'top', 'top center', 'bottom center'].includes(value),
    },
    origin: {
      type: String,
      default: 'auto',
      validator: (value) => ['top center', 'end center', 'end top', 'bottom center', 'auto'].includes(value),
    },
    title: {
      type: String,
      required: true,
    },
    isHtml: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.table-header {
  .info-icon {
    color: $gray-600;
  }
}

.info-icon {
  color: $icon-grey;
  vertical-align: text-top;
  cursor: pointer;
  display: inline-block;
  width: 18px;
  height: 18px;
  em {
    font-size: 18px;
    vertical-align: top;
  }
}
</style>
